import { render, staticRenderFns } from "./SInputTextarea.vue?vue&type=template&id=b43b26fa&scoped=true"
import script from "./sInputTextarea.ts?vue&type=script&lang=ts&external"
export * from "./sInputTextarea.ts?vue&type=script&lang=ts&external"
import style0 from "./SInputTextarea.vue?vue&type=style&index=0&id=b43b26fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43b26fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b43b26fa')) {
      api.createRecord('b43b26fa', component.options)
    } else {
      api.reload('b43b26fa', component.options)
    }
    module.hot.accept("./SInputTextarea.vue?vue&type=template&id=b43b26fa&scoped=true", function () {
      api.rerender('b43b26fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-input-textarea/SInputTextarea.vue"
export default component.exports